import { ItemDish } from "./ItemDish";

export default ItemDish;
